import React, { useEffect, useState } from 'react';
import { Row } from 'antd';

import { TitleSections } from '../../../../components/TitleSections';
import InfoProprietarioLeitura from './infoProprietarioLeitura';
import InfoProprietarioEdicao from './infoProprietarioEdicao';
import { useAuth } from '../../../../hooks/auth';

export function InfoProprietario({
  proprietario,
  carregarSolicitacaoAtual,
  setSpinning,
  tipoValidacao,
}) {
  const tituloSecao = proprietario?.detalheTipoCadastro;
  const [readOnly, setReadOnly] = useState(true);
  const [isAdministrador, setIsAdministrador] = useState(false);
  const { temPermissao } = useAuth();
  useEffect(() => {
    const isAdmin =
      temPermissao(['EditarCadastroPainel']) && tipoValidacao === 1;
    setIsAdministrador(isAdmin);
  }, [temPermissao]);
  return (
    <>
      <TitleSections
        title={`Dados cadastrais do ${tituloSecao} `}
        withButton={!!isAdministrador}
        buttonText="Editar"
        readOnly={readOnly}
        setReadOnly={setReadOnly}
        // textColorButton="#828282"
      />
      <Row
        justify="space-between"
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
        }}
      >
        {readOnly ? (
          <InfoProprietarioLeitura proprietario={proprietario} />
        ) : (
          <InfoProprietarioEdicao
            proprietario={proprietario}
            carregarSolicitacaoAtual={carregarSolicitacaoAtual}
            setSpinning={setSpinning}
            setReadOnly={setReadOnly}
          />
        )}
      </Row>
    </>
  );
}
